__turbopack_context__.v({
  "IsLoading": "I72I0W_IsLoading",
  "SAverageMarkerStar": "I72I0W_SAverageMarkerStar",
  "SHeading": "I72I0W_SHeading",
  "SNumRated": "I72I0W_SNumRated",
  "SRatingsDisplay": "I72I0W_SRatingsDisplay",
  "SStarContainer": "I72I0W_SStarContainer",
  "SUserRatingMarkerStar": "I72I0W_SUserRatingMarkerStar",
  "SYourRatingHeading": "I72I0W_SYourRatingHeading",
});
